import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

function PlayerTypeButton() {
    const location = useLocation();

    const locationSplit = location['pathname'].split('/');
    const playerType = locationSplit[1];
    const playerId = locationSplit[2];

    function playerTypeCalc(btnType) {
        if(btnType === "batter" && playerType === "batter") {
            return 'active';
        } else if(btnType === "pitcher" && playerType === "pitcher") {
            return 'active';
        } else {
            return '';
        }
    }

    function playerTypeClickEventHandler(event) {
        let playerValue = event.target.value;

        if(playerValue !== playerType) {
            window.location.href = "/"+playerValue+"/"+playerId;
        }
    }

    return (
        <>
        <ButtonGroup aria-label="Basic example" style={{float: 'left', marginLeft: '5px'}}>
            <Button 
            variant="secondary" size="sm" value="batter" 
            active={playerTypeCalc("batter")}
            onClick={playerTypeClickEventHandler}>타자</Button>
            <Button 
            variant="secondary" size="sm" value="pitcher" 
            active={playerTypeCalc("pitcher")}
            onClick={playerTypeClickEventHandler}>투수</Button>
        </ButtonGroup>
        </>
    )   
}

export default PlayerTypeButton;